// Exports the "nonbreaking" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/nonbreaking')
//   ES2015:
//     import 'tinymce/plugins/nonbreaking'
require('./plugin.js');


/*****************
 ** WEBPACK FOOTER
 ** ./~/tinymce/plugins/nonbreaking/index.js
 ** module id = 529
 ** module chunks = 1
 **/